export default __webpack_public_path__ + "static/media/morse_intro_de.11a08a31.mp3";